




import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Thumbnail',
  props: {
    imageFile: File as PropType<File>,
    defaultImage: String,
  },
  data() {
    return {
      imageChanged: false,
      imageUrl: require('../../../../assets/img/placeholder.svg'),
    };
  },
  watch: {
    imageFile(file) {
      if (file && file.type && file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      }
      this.imageChanged = true;
    },
  },
});
